var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentComponent,_vm._b({tag:"component"},'component',{ ..._vm.properties, abTesting: _vm.abTesting, originalComponent: _vm.originalComponent },false))
}
var staticRenderFns = []

export { render, staticRenderFns }